<template>
  <div class="box ieorg">
    
    <indexHeader></indexHeader>
    <div class="account">
      <div class="account-list-box">
        <div class="account-list"   v-for="(item,index) in list" :key="index"   @click="detail(item.id)">
         
          <div class="account-top">
            <img :src="item.logo">
            <span :style="item.time_status==1?'background:#999':'background:#f0b90b'">{{item.time_status==1?$t('zdy.wks'):item.time_status==2?$t('zdy.jxz'):$t('zdy.yjs')}}</span>
          </div>
          <div class="account-btm-box">
          <div class="account-center">
            <h1>{{item.title}}</h1>
            <span>{{item.summary}}</span>
          </div>
          <div class="account-bottom">
            <article>
              <span>{{$t('zdy.fhzl')}}</span>
              <em>{{item.amount}} {{item.currency_name}}</em>
            </article>
            <article>
              <span>{{$t('zdy.jssj')}}</span>
              <em>{{item.end_at}}</em>
            </article>
          </div>
          </div>

          </div>
        </div>
    </div>
  </div>
</template>
<script>
import indexHeader from "@/view/indexHeader";
export default {
  name: "ieorg",
  data() {
    return {
      listBool:true,
      isAchiveBottom:true,
      list:[],
      page:1,
    };
  },
  components: {
    indexHeader
  },
  created() {
    window.addEventListener('scroll',this.handtop);
    this.init();
  },
  methods: {
    handtop(){
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop =document.documentElement.scrollTop || document.body.scrollTop;
      //变量windowHeight是可视区的高度
      var windowHeight =document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      var scrollHeight =document.documentElement.scrollHeight || document.body.scrollHeight;
      //滚动条到底部的条件(距底部20px时触发加载)
      if (scrollTop + windowHeight >= scrollHeight - 20 && this.isAchiveBottom && this.listBool) {
      
        //延时触发数据加载
        setTimeout(() => {
          this.init();
        }, 500);
      }
    },
    init(){
      let that=this;
      this.token = localStorage.getItem("token") || "";
      if(this.listBool){
        that.listBool=false;
        this.$http({
          url: "/api/project?limit=30&page="+this.page,
          method: "get",
          headers: { Authorization: this.token }
        }).then(res => {        
          that.page+=1;
          that.listBool=true;
          if (res.data.type == "ok") {
            if(res.data.message.list.length){
              that.list=that.list.concat(res.data.message.list);
              console.log(that.list);
            }else{
              that.isAchiveBottom=false;
            }
          }
        });
      }
    },
    detail(id){
      this.$router.push({path: '/ieorgDetail', query: {id: id}});
    }
  }
};
</script>

<style lang="scss" scoped>
.account-center span {
    font-size: 12px;
    color: #333;
    word-break: break-all;
    display: -webkit-box;
    overflow: hidden;
    height: 100px;
    max-height: 100px;
}
.account-center h1{
  padding-bottom: 5px;
  border-bottom:1px solid #ddd;
}
.account-center span{
  font-size: 12px;
  color:#333;
}
.account-bottom{
  margin-top: 20px;
}
.account-bottom article{
  margin-top: 3px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 12px;
  color:#333;
}
.account-btm-box{
  color:#000;
  background: #fff;
  padding: 10px 3%;
}
.account-list-box{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.account-list:hover{
  top:-5px;
}
.account-list{
  box-shadow: 1px 1px 10px rgba(0,0,0,0.1);
  position: relative;
  cursor: pointer;
  width:280px;
  margin-right: 20px;
  margin-bottom: 15px;
}
.account-top span{
  color:#fff;
  position: absolute;
  top: 5px;
  right:0;
  padding: 3px 10px;
  background:#f0b90b
}
.account-top img{
  width: 100%;
  height:100%;
}
.account-top{
  position: relative;
  width:100%;
  height: 198px;
}
.wt150 {
  width: 150px;
}
.box .account {
  width: 1200px;
  margin: 0 auto 82px;
  margin-top: 30px;
}
.topcontent {
  padding: 22px 30px;
  margin-bottom: 20px;
  // background-color: #1a2330;
  border-radius: 5px;
}
.account_title {
  padding: 15px 20px;
}
select {
  background-color: transparent;
  padding: 10px;
  // color: #c7cce6;
  font-size: 18px;
  border-radius: 3px;
  // border: 1px solid #4e5b85;
}
select.ft14 {
  font-size: 14px;
}
select > option {
  padding: 10px 0;
  background-color: transparent;
}
input {
  padding: 10px;
  // border: 1px solid #4e5b85;
  font-size: 18px;
  // color: #c7cce6;
  border-radius: 3px;
  background-color: transparent;
  outline: none;
}
.add {
  // text-align: right;
  margin-top: 20px;
}
.add .baseBtn {
  width: 100%;
  margin-top: 60px;
}
.btn {
  width: 150px;
  height: 100%;
  line-height: 42px;
  border-radius: 3px;
  background: #357ce1;
  color: #fff;
  margin-left: 20px;
}
.pb10 {
  padding: 10px;
}
.mb10 {
  margin-bottom: 10px;
}
.ptb10{
  padding-top: 10px;
  padding-bottom: 10px;
}
.plr10{
  padding-left: 10px;
  padding-right: 10px;
}
</style>





// WEBPACK FOOTER //
// src/view/ieorg.vue